import { Link } from "@tanstack/react-router";

export const NotFoundPage = () => (
  <div className="text-center py-5">
    <h1 className="display-6">Página não encontrada</h1>
    <Link to="/" className="btn btn-primary mt-3">
      Voltar ao início
    </Link>
  </div>
);
